import { GET } from './Clients';

async function getAppList({ name }) {
  return GET({
    url: `/core/config-manager/v1/app/list?q=${JSON.stringify({ name })}`,
    isBasic: true,
  });
}

async function getAppValueByCode({ ctx, appCode }) {
  return GET({
    url: `/core/config-manager/v1/app-value/single?appCode=${appCode}`,
    isBasic: true,
    // Endpoint config-manager chỉ chấp nhận Basic auth. isAuth: false để KHÔNG gắn
    // Bearer token của user (gây 403 khi gọi ở client lúc đã đăng nhập) -> luôn dùng BASIC_AUTHEN.
    isAuth: false,
    ctx,
  });
}

export default {
  getAppList,
  getAppValueByCode,
};
